import { type Color } from '@mui/material'

export const green = {
  100: '#0B1F14',
  200: '#0A311C',
  300: '#08552A',
  400: '#057939',
  500: '#039D48',
  600: '#00C157',
  700: '#33CD79',
  800: '#66DA9A',
  900: '#99E6BC',
} satisfies Partial<Color>
